import { useCallback, useMemo } from 'react';

import { useRecoilState } from 'recoil';

import { useMacrosContext } from 'lib/context/MacrosContext/MacrosContext';

import { clinicalNote as clinicalNoteState } from 'components/state';

const useClinicalNoteState = ({ isMacro }) => {
  const [clinicalNote, setClinicalNote] = useRecoilState(clinicalNoteState);

  const { customCN, setCustomCN } = useMacrosContext();

  const cn = useMemo(() => customCN?.clinicalNote, [customCN?.clinicalNote]);
  const setCN = useCallback(
    (value) => {
      setCustomCN((prev) => {
        const prevCN = prev?.clinicalNote;

        const newCN = typeof value === 'function' ? value(prevCN) : value;

        return { ...(prev || {}), clinicalNote: newCN };
      });
    },
    [setCustomCN]
  );

  if (isMacro) return [cn, setCN];

  return [clinicalNote, setClinicalNote];
};

export default useClinicalNoteState;
